var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vx-card",
    { attrs: { title: "Pagination", "code-toggler": "" } },
    [
      _c("p", [
        _vm._v("You can add a paginated table with the pagination property"),
      ]),
      _c(
        "vs-alert",
        {
          staticClass: "my-3",
          attrs: { color: "primary", icon: "new_releases", active: "true" },
        },
        [
          _c("p", [
            _vm._v(
              "by default the maximum number of elements per page is 5 to change it using the max-items property"
            ),
          ]),
        ]
      ),
      _c("br"),
      _c(
        "vs-table",
        {
          attrs: { "max-items": "3", pagination: "", data: _vm.users },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ data }) {
                return _vm._l(data, function (tr, indextr) {
                  return _c(
                    "vs-tr",
                    { key: indextr },
                    [
                      _c("vs-td", { attrs: { data: data[indextr].email } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(data[indextr].email) +
                            "\n                    "
                        ),
                      ]),
                      _c("vs-td", { attrs: { data: data[indextr].username } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(data[indextr].username) +
                            "\n                    "
                        ),
                      ]),
                      _c("vs-td", { attrs: { data: data[indextr].id } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(data[indextr].website) +
                            "\n                    "
                        ),
                      ]),
                      _c("vs-td", { attrs: { data: data[indextr].id } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(data[indextr].id) +
                            "\n                    "
                        ),
                      ]),
                    ],
                    1
                  )
                })
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "thead" },
            [
              _c("vs-th", [_vm._v("Email")]),
              _c("vs-th", [_vm._v("Name")]),
              _c("vs-th", [_vm._v("Website")]),
              _c("vs-th", [_vm._v("Nro")]),
            ],
            1
          ),
        ],
        2
      ),
      _c("template", { slot: "codeContainer" }, [
        _vm._v(
          '\n<template lang="html">\n  <div>\n    <vs-table max-items="3" pagination :data="users">\n\n      <template slot="thead">\n        <vs-th>Email</vs-th>\n        <vs-th>Name</vs-th>\n        <vs-th>Website</vs-th>\n        <vs-th>Nro</vs-th>\n      </template>\n\n      <template slot-scope="{data}">\n        <vs-tr :key="indextr" v-for="(tr, indextr) in data">\n\n          <vs-td :data="data[indextr].email">\n            ' +
            _vm._s("{{ data[indextr].email }}") +
            '\n          </vs-td>\n\n          <vs-td :data="data[indextr].username">\n            ' +
            _vm._s("{{ data[indextr].username }}") +
            '\n          </vs-td>\n\n          <vs-td :data="data[indextr].id">\n            ' +
            _vm._s("{{ data[indextr].website }}") +
            '\n          </vs-td>\n\n          <vs-td :data="data[indextr].id">\n            ' +
            _vm._s("{{ data[indextr].id }}") +
            '\n          </vs-td>\n\n        </vs-tr>\n      </template>\n    </vs-table>\n  </div>\n</template>\n\n<script>\nexport default {\n  data: () => ({\n    users: [\n      {\n        "id": 1,\n        "name": "Leanne Graham",\n        "username": "Bret",\n        "email": "Sincere@april.biz",\n        "website": "hildegard.org",\n      },\n      {\n        "id": 2,\n        "name": "Ervin Howell",\n        "username": "Antonette",\n        "email": "Shanna@melissa.tv",\n        "website": "anastasia.net",\n      },\n      {\n        "id": 3,\n        "name": "Clementine Bauch",\n        "username": "Samantha",\n        "email": "Nathan@yesenia.net",\n        "website": "ramiro.info",\n      },\n      {\n        "id": 4,\n        "name": "Patricia Lebsack",\n        "username": "Karianne",\n        "email": "Julianne.OConner@kory.org",\n        "website": "kale.biz",\n      },\n      {\n        "id": 5,\n        "name": "Chelsey Dietrich",\n        "username": "Kamren",\n        "email": "Lucio_Hettinger@annie.ca",\n        "website": "demarco.info",\n      },\n      {\n        "id": 6,\n        "name": "Mrs. Dennis Schulist",\n        "username": "Leopoldo_Corkery",\n        "email": "Karley_Dach@jasper.info",\n        "website": "ola.org",\n      },\n      {\n        "id": 7,\n        "name": "Kurtis Weissnat",\n        "username": "Elwyn.Skiles",\n        "email": "Telly.Hoeger@billy.biz",\n        "website": "elvis.io",\n      },\n      {\n        "id": 8,\n        "name": "Nicholas Runolfsdottir V",\n        "username": "Maxime_Nienow",\n        "email": "Sherwood@rosamond.me",\n        "website": "jacynthe.com",\n      },\n      {\n        "id": 9,\n        "name": "Glenna Reichert",\n        "username": "Delphine",\n        "email": "Chaim_McDermott@dana.io",\n        "website": "conrad.com",\n      },\n      {\n        "id": 10,\n        "name": "Clementina DuBuque",\n        "username": "Moriah.Stanton",\n        "email": "Rey.Padberg@karina.biz",\n        "website": "ambrose.net",\n      }\n    ]\n  }),\n}\n</script>\n        '
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }